import SyncBlockContainer from './SyncBlockContainer';

export default SyncBlockContainer;
